import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthState } from '../state/auth.state';
import { LeaguesState } from '../state/leagues.state';

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthState);
  const leagues = inject(LeaguesState);
  const router = inject(Router);

  if (!auth.currentUser()) {
    return true;
  }

  if (leagues.currentLeague()) {
    return router.createUrlTree(['/dashboard']);
  }

  return router.createUrlTree(['/leagues']);
};
